<template>
	<router-link class="app-entry funnel_app_item" :to="url" :key="app.id">
		<div class="left">
			<div class="img_wrpr">
				<img v-if="!!app.image_url" :src="app.image_url" alt="">
				<img v-else :src="'data:image/png;base64,'+app.image" alt="">
			</div>
			<div class="text_content">
				<h3>{{app.name}}</h3>
				<p>{{app.description}}</p>
			</div>
		</div>
		<label v-if="!toggling" class="switch_checkbox_item" @click.stop>
			<input type="checkbox" :checked="app.funnel_app.active" @change="toggleActive($event.target.checked)">
			<div class="switch_checkbox"><span></span></div>
		</label>
		<div v-else class="switch_checkbox_item" style="position: relative;width: 48px">
			<v-spinner />
		</div>
	</router-link>
</template>

<script>
import API from "@/api"
import VSpinner from "@/components/base/v-spinner";

export default {
	name: "app-entry",
	components: {VSpinner},
	mixins: [API],
	props: ["app", "url", "isPlus"],
	data() {
		return {
			toggling: false,
		}
	},
	methods: {
		async toggleActive(active) {
			try {
				this.toggling = true;
				this.app.funnel_app.active = active;
				let result = {};

				if (this.isPlus) {
					result = await this.api.apps.patchFunnelApp(this.$route.params.id, this.app.funnel_app);
				} else {
					result = await this.api.apps.patch(this.$route.params.id, this.app.funnel_app);
				}
				if (result.status === 200) throw result
			} catch (e) {
				console.error("ERROR", e);
				this.$notify({
					type: 'error',
					group: 'main',
					title: 'Server error. Please try again later'
				});
			} finally {
				this.toggling = false;
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.app-entry {

}
</style>
